import { AUTH_SUCCESS } from "../actions/types"

const initialState = {
    isLoggedIn: false
}

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_SUCCESS:
            return Object.assign({}, state, {
                isLoggedIn: action.payload,
            });
        default:
            return state
    }
}

export default authReducer;
